import type { CreateRestaurantReservation } from "../Objects/RestaurantReservation/RestaurantReservationTypes"

const STORAGE_KEY_PREFIX = "pending-restaurant-reservation"

const getStorageKey = (restaurantSlug: string) => `${STORAGE_KEY_PREFIX}:${restaurantSlug}`

const isPendingReservation = (value: unknown): value is CreateRestaurantReservation => {
  if (!value || typeof value !== "object") return false

  const candidate = value as Partial<CreateRestaurantReservation>

  return Number.isInteger(candidate.areaId)
    && Number(candidate.areaId) > 0
    && typeof candidate.date === "string"
    && candidate.date.length > 0
    && typeof candidate.time === "string"
    && candidate.time.length > 0
    && Number.isInteger(candidate.partySize)
    && Number(candidate.partySize) > 0
    && (candidate.notes === undefined || typeof candidate.notes === "string")
}

export const savePendingRestaurantReservation = (
  restaurantSlug: string,
  reservation: CreateRestaurantReservation,
) => {
  window.sessionStorage.setItem(getStorageKey(restaurantSlug), JSON.stringify(reservation))
}

export const getPendingRestaurantReservation = (
  restaurantSlug: string,
): CreateRestaurantReservation | null => {
  const storedValue = window.sessionStorage.getItem(getStorageKey(restaurantSlug))

  if (!storedValue) return null

  try {
    const parsedValue: unknown = JSON.parse(storedValue)

    if (isPendingReservation(parsedValue)) return parsedValue
  } catch {
    // O valor inválido é removido abaixo para não bloquear futuros fluxos.
  }

  window.sessionStorage.removeItem(getStorageKey(restaurantSlug))
  return null
}

export const clearPendingRestaurantReservation = (restaurantSlug: string) => {
  window.sessionStorage.removeItem(getStorageKey(restaurantSlug))
}
